import { render, staticRenderFns } from "./MortgagePickerPopUp.vue?vue&type=template&id=20ef2560&scoped=true&"
import script from "./MortgagePickerPopUp.vue?vue&type=script&lang=js&"
export * from "./MortgagePickerPopUp.vue?vue&type=script&lang=js&"
import style0 from "./MortgagePickerPopUp.vue?vue&type=style&index=0&id=20ef2560&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ef2560",
  null
  
)

export default component.exports